var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAppDesigner)?_c('div',{class:_vm.$style.root},[_vm._v(_vm._s(_vm.initialTime))]):_c('div',{class:_vm.$style.root},[_vm._v(_vm._s(_vm.crtTime))])}
var staticRenderFns = []

export { render, staticRenderFns }